'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('@slate-editor/components');

var _GridUtils = require('./GridUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line react/prop-types
var GridButton = function GridButton(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      className = _ref.className,
      style = _ref.style,
      type = _ref.type;
  return _react2.default.createElement(
    _components.Button,
    {
      style: style,
      type: type
      // eslint-disable-next-line react/prop-types
      , onClick: function onClick() {
        return onChange((0, _GridUtils.appendGrid)(value.change()));
      },
      className: (0, _classnames2.default)('slate-grid-plugin--button', { active: (0, _GridUtils.hasGrid)(value) }, className)
    },
    _react2.default.createElement(_reactFontawesome2.default, { name: 'th' })
  );
};

exports.default = GridButton;